// extracted by mini-css-extract-plugin
export var lg = "_3j-4";
export var md = "_3j-3";
export var sm = "_3j-2";
export var xs = "_3j-1";
export var xxs = "_3j-0";